import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { useLocalePath } from "@/hooks/useLocalePath";
import { m, AnimatePresence } from "framer-motion";

const COOKIE_KEY = "wise-compass-cookie-consent";

const CookieBanner = () => {
  const { language } = useLanguage();
  const { getPath } = useLocalePath();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (consent) return;
    const timer = setTimeout(() => setVisible(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_KEY, "accepted");
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_KEY, "declined");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <m.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", damping: 25, stiffness: 200 }}
          className="fixed bottom-0 inset-x-0 z-50 p-4 md:p-6"
        >
          <div className="container mx-auto max-w-3xl">
            <div className="bg-background border border-border rounded-2xl shadow-lg px-6 py-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <p className="text-sm text-muted-foreground leading-relaxed flex-1">
                {language === "fr"
                  ? "Nous utilisons des cookies pour améliorer votre expérience. En continuant, vous acceptez notre "
                  : "We use cookies to enhance your experience. By continuing, you agree to our "}
                <Link
                  to={getPath("/privacy")}
                  className="underline text-foreground hover:text-primary transition-colors"
                >
                  {language === "fr" ? "politique de confidentialité" : "privacy policy"}
                </Link>
                .
              </p>

              <div className="flex items-center gap-3 shrink-0">
                <button
                  onClick={handleDecline}
                  className="cursor-pointer px-4 py-2 text-sm rounded-lg border border-border text-muted-foreground hover:text-foreground hover:border-foreground/30 transition-colors whitespace-nowrap"
                >
                  {language === "fr" ? "Refuser" : "Decline"}
                </button>
                <button
                  onClick={handleAccept}
                  className="cursor-pointer px-4 py-2 text-sm rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 transition-colors whitespace-nowrap"
                >
                  {language === "fr" ? "Accepter" : "Accept"}
                </button>
              </div>
            </div>
          </div>
        </m.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
